import React, { useContext } from 'react';
import { string } from 'prop-types';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import {
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { isArticleCanonical, isNotFound } from './rules/article-redirect-rules';
import { handleErrors, setUrlContext } from '../utils/redirector-utils';

const articleHandler = ({ data, error, props }) => {

  let [path, queryParams = ''] = props.pathWithQueryParams?.split('?') || '';

  path = setUrlContext(path, '/c/');

  const debug = queryParams.indexOf('debug') > -1;

  const errors = handleErrors(error);
  if (errors) {
    return new RedirectTag(errors, props.bypass);
  }
  const notFound = isNotFound({ data });
  if (notFound) {
    return new RedirectTag(notFound, props.bypass);
  }

  const articleCanonical = isArticleCanonical({ data, path });
  if (articleCanonical && !debug) {
    return new RedirectTag(articleCanonical, props.bypass);
  }
  return null;
};

export const ArticleRedirector = ({ articleGUID }) => {

  const { pathWithQueryParams, bypass } = useContext(RedirectContext);

  const { data, error } = useDataModel('article', {
    variables: { articleGUID },
  });

  useHelmet('articleRedirector', { data, error, props: { bypass, pathWithQueryParams } }, articleHandler, []);

  return null;
};

ArticleRedirector.displayName = 'ArticleRedirector';

ArticleRedirector.propTypes = {
  articleGUID: string.isRequired
};

ArticleRedirector.defaultProps = {};

ArticleRedirector.dataModel = {
  article: params({ articleGUID: stringType() }).shape({
    metadata: shape({
      canonicalURL: stringType()
    })
  }),
};
